export const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB

export const RELOAD_INTERVAL_TIME = 30 * 1000; // reload each 30 seconds

export const MAX_RELOAD_TIMES = 5; // 6 times (starting with 0) & each reload takes 30 seconds = 3 minutes
